import { useEffect, useRef, useState } from 'react';
import { useAuth } from '@/app/providers/AuthProvider';
import { useScopedNavigate } from '@/app/providers/TenantScopeProvider';
import type { ScopedRouteKey } from '@/app/routes';

interface MenuItem {
  routeKey: ScopedRouteKey;
  label: string;
  icon: string;
}

const MENU: MenuItem[] = [
  { routeKey: 'profile', label: 'Профайл', icon: 'person' },
  { routeKey: 'companySettings', label: 'Байгууллагын тохиргоо', icon: 'gear' },
  { routeKey: 'shopStore', label: 'Онлайн дэлгүүр', icon: 'shop-window' },
  { routeKey: 'terminals', label: 'ПОС терминалууд', icon: 'pc-display-horizontal' },
  { routeKey: 'invoices', label: 'Багцын нэхэмжлэх', icon: 'receipt-cutoff' },
];

export function UserMenu() {
  const { snapshot, logout } = useAuth();
  const navScoped = useScopedNavigate();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const avatarText = (snapshot.phone ?? '').slice(-2) || 'МХ';
  const phone = snapshot.phone ?? '';

  useEffect(() => {
    if (!open) return;
    const onClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, [open]);

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button
        type="button"
        className="ts-avatar"
        onClick={() => setOpen((x) => !x)}
        title={phone ? `+976 ${phone}` : 'Профайл'}
        aria-haspopup="menu"
        aria-expanded={open}
        style={{ border: 0, cursor: 'pointer' }}
      >
        {avatarText}
      </button>
      {open ? (
        <div role="menu" className="ts-menu" style={{ minWidth: 240 }} aria-label="Хэрэглэгчийн цэс">
          <div className="ts-menu-head">
            <div className="ts-menu-head-name">{snapshot.displayName ?? 'Хэрэглэгч'}</div>
            <div className="ts-menu-head-sub">{phone ? `+976 ${phone}` : 'Утас алга'}</div>
          </div>
          {MENU.map((m) => (
            <button
              key={m.routeKey}
              type="button"
              role="menuitem"
              className="ts-menu-item"
              onClick={() => {
                navScoped(m.routeKey);
                setOpen(false);
              }}
            >
              <i className={`bi bi-${m.icon}`} />
              <span style={{ flex: 1 }}>{m.label}</span>
            </button>
          ))}
          <div className="ts-menu-sep" />
          <button
            type="button"
            role="menuitem"
            className="ts-menu-item danger"
            onClick={() => {
              setOpen(false);
              logout();
            }}
          >
            <i className="bi bi-box-arrow-right" />
            <span style={{ flex: 1 }}>Гарах</span>
          </button>
        </div>
      ) : null}
    </div>
  );
}
